import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { Grid, TextField } from '@mui/material';
import { isNull } from 'lodash/lang';

import { NSPP_REIMBURSEMENT } from '../../../../../../../../../services/i18n/namespaces';
import { normalizeOneDecimalPositiveFloat } from '../../../../../../../../../services/normalizers';

export default memo(function DistanceField({ distance, setAddressField, handleBlur, error, helperText }) {
  const { t } = useTranslation();
  const value = distance || '';

  return (
    <Grid size={3}>
      <TextField
        name="mileageAddresses.distance"
        value={value}
        onChange={function({ target }) {
          const prepareValue = normalizeOneDecimalPositiveFloat(target.value);
          if (!isNull(prepareValue)) {
            setAddressField('mileageAddresses.distance', prepareValue);
          }
        }}
        onBlur={handleBlur}
        error={error}
        helperText={helperText}
        fullWidth
        label={t(`${NSPP_REIMBURSEMENT}:mileageAddresses.distance`)}
        variant="standard"
        required
        slotProps={{
          input: {
            type: 'number'
          }
        }}
      />
    </Grid>
  );
});
